// extracted by mini-css-extract-plugin
module.exports =  {"errorPage":"RhE27aSIB5yGBkjGrzUx","heading":"C2UjLuVgZFcPyve0Ri1S"};